<template>
    <div id="content">
        <Splash></Splash>
        <Services></Services>
        <Vehicles></Vehicles>
        <References></References>
        <Contact></Contact>
    </div>
</template>

<script>
import Splash from "./components/Splash";
import Services from "./components/Services/Services.vue";
import Vehicles from "./components/Vehicles";
import References from "./components/References/References";
import Contact from "./components/Contact";

export default {
  components: {
    Splash,
    Services,
    Vehicles,
    References,
    Contact
  },
  mounted() {
    window.onload = () => {


      setTimeout(() => {
        window.scrollTo(0, 0);
        window.EventBus.$emit("page-loaded");
      }, 1);
    };
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Page.vue